import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      <section className="pt-32 pb-20 bg-beige">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center mb-16">
            <p className="text-sm text-warmGray mb-4">(Hikayemiz)</p>
            <h1 className="text-5xl md:text-6xl font-display font-bold text-navy mb-6">
              Atölyemini ile Her Köşe Bir Macera
            </h1>
            <p className="text-lg text-warmGray leading-relaxed">
              Çocukların hayal güçlerini besleyen, güvenli ve estetik mobilyalar tasarlıyoruz
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-20">
            <div className="relative h-[500px] rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/2ad2f407e0584d46f9717d6c946e0930.jpg"
                alt="Atölyemini Hikayesi"
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div>
              <h2 className="text-3xl font-display font-bold text-navy mb-6">
                Montessori Felsefesi ve İskandinav Estetiği
              </h2>
              <p className="text-warmGray leading-relaxed mb-6">
                Atölyemini olarak, çocukların hayal güçlerini besleyen, güvenli ve estetik mobilyalar tasarlıyoruz. 
                Montessori felsefesinden ilham alan ürünlerimiz, İskandinav tasarım anlayışıyla buluşuyor.
              </p>
              <p className="text-warmGray leading-relaxed mb-6">
                Her bir ürünümüz, çocukların gelişimine katkı sağlayacak şekilde özenle tasarlanmış ve doğal ahşap 
                malzemelerden üretilmiştir. Anaokulları, okul öncesi kurumları ve oyun alanları için özel çözümler sunuyoruz.
              </p>
              <p className="text-warmGray leading-relaxed">
                Türkiye genelinde 150'den fazla anaokulu, oyun kafesi ve çocuk aktivite merkezine mobilya çözümleri sunduk. 
                Her proje, çocukların gelişimine katkı sağlayan özel tasarımlarla hayata geçirildi.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl">
              <div className="w-16 h-16 flex items-center justify-center bg-mint rounded-full mb-6">
                <i className="ri-plant-line text-3xl text-navy"></i>
              </div>
              <h3 className="text-xl font-semibold text-navy mb-4">Doğal Malzemeler</h3>
              <p className="text-warmGray leading-relaxed">
                Tüm ürünlerimiz doğal ahşap malzemelerden üretilir ve çocuklar için güvenli boyalarla boyanır.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl">
              <div className="w-16 h-16 flex items-center justify-center bg-mint rounded-full mb-6">
                <i className="ri-shield-check-line text-3xl text-navy"></i>
              </div>
              <h3 className="text-xl font-semibold text-navy mb-4">Güvenlik Standartları</h3>
              <p className="text-warmGray leading-relaxed">
                Tüm ürünlerimiz uluslararası güvenlik standartlarına uygun olarak tasarlanır ve üretilir.
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl">
              <div className="w-16 h-16 flex items-center justify-center bg-mint rounded-full mb-6">
                <i className="ri-lightbulb-line text-3xl text-navy"></i>
              </div>
              <h3 className="text-xl font-semibold text-navy mb-4">Eğitici Tasarım</h3>
              <p className="text-warmGray leading-relaxed">
                Montessori felsefesine uygun tasarımlarımız çocukların gelişimine katkı sağlar.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;